export default __webpack_public_path__ + "static/media/clock_arrow_up.d589bbc6.svg";